/* ==========================================================
   Zewye90 — product.js
   Frame colour swatch, quantity stepper, app-options slot,
   sticky mobile buy bar.
   ========================================================== */
(function () {
  'use strict';

  /* ---------------- frame colour ----------------
     The swatch is a line item property, not a variant. It applies to one
     material only, so when another is chosen the inputs are disabled — a
     disabled input is left out of the form data entirely, so no stray
     Frame Color lands on a poster or wood print order. */
  (function () {
    var sw = document.querySelector('[data-swatch]');
    if (!sw) return;

    var pos = sw.dataset.option;
    var when = (sw.dataset.when || '').trim().toLowerCase();
    var inputs = Array.prototype.slice.call(sw.querySelectorAll('[data-swatch-input]'));
    var current = sw.querySelector('[data-swatch-current]');
    if (!pos || !inputs.length) return;

    var sel = 'input[name=option' + pos + ']';
    var watched = document.querySelectorAll(sel);

    function applies() {
      var picked = document.querySelector(sel + ':checked');
      return !!picked && picked.value.trim().toLowerCase() === when;
    }

    function sync() {
      var on = applies();
      sw.hidden = !on;
      inputs.forEach(function (i) { i.disabled = !on; });
    }

    watched.forEach(function (r) { r.addEventListener('change', sync); });

    inputs.forEach(function (i) {
      i.addEventListener('change', function () {
        if (current && i.checked) current.textContent = i.value;
      });
    });

    sync();
  })();

  /* ---------------- app options slot ----------------
     Option apps inject their fields immediately before the add-to-cart
     button. Anything in the actions area the theme did not render is
     moved into .pdp-appslot, which sits above the quantity row. */
  (function () {
    var actions = document.querySelector('.pdp-actions');
    if (!actions) return;
    var slot = actions.querySelector('.pdp-appslot');
    if (!slot) return;

    function isOurs(el) {
      return el === slot ||
             el.hasAttribute('data-swatch') ||
             el.classList.contains('pdp-qtywrap') ||
             el.classList.contains('pdp-add') ||
             el.classList.contains('shopify-payment-button') ||
             el.tagName === 'SCRIPT' ||
             el.tagName === 'STYLE';
    }

    var moving = false;
    function collect() {
      if (moving) return;
      moving = true;
      Array.prototype.slice.call(actions.children).forEach(function (el) {
        if (!isOurs(el)) slot.appendChild(el);
      });
      moving = false;
    }

    collect();
    if ('MutationObserver' in window) {
      new MutationObserver(collect).observe(actions, { childList: true });
    }
  })();

  /* ---------------- quantity ---------------- */
  var qty = document.querySelector('[data-qty]');
  if (qty) {
    var input = qty.querySelector('input');
    function step(by) {
      var n = parseInt(input.value, 10);
      if (isNaN(n)) n = 1;
      n = Math.max(1, n + by);
      input.value = n;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var down = qty.querySelector('[data-qty-down]');
    var up = qty.querySelector('[data-qty-up]');
    if (down) down.addEventListener('click', function () { step(-1); });
    if (up) up.addEventListener('click', function () { step(1); });
    input.addEventListener('blur', function () {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) input.value = 1;
    });
  }

  /* ---------------- option label in the legend ---------------- */
  document.querySelectorAll('input[type=radio][name^=option]').forEach(function (r) {
    r.addEventListener('change', function () {
      var p = r.name.replace('option', '');
      var label = document.querySelector('[data-opt-label="' + p + '"]');
      if (label) label.textContent = r.value;
    });
  });

  /* ---------------- sticky buy bar ---------------- */
  var bar = document.querySelector('[data-pbar]');
  var mainAdd = document.querySelector('[data-add]');
  if (bar && mainAdd) {
    var barAdd = bar.querySelector('[data-pbar-add]');
    var barPrice = bar.querySelector('[data-pbar-price]');

    function show(on) {
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          show(!e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(mainAdd);
    }

    if (barAdd) barAdd.addEventListener('click', function () { mainAdd.click(); });

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      if (barPrice) barPrice.innerHTML = v.price_html;
      if (barAdd) {
        barAdd.disabled = !v.available;
        barAdd.textContent = v.available ? mainAdd.dataset.addLabel : mainAdd.dataset.soldout;
      }
    });
  }
})();
